import React, { useEffect, useState } from "react";
import { Oval } from "../../assets/imagesPath";
import Select from "react-select";
import { useForm } from "react-hook-form";
import Dropdown from "../../assets/icons/Dropdown";
import { useNavigate } from "react-router-dom";
import PATHS from "../../routes/Paths";
import { useDispatch, useSelector } from "react-redux";
import { emptyBusinessForm } from "../../redux/AuthSlice";
import { useRegisterBusinessFormMutation } from "../../services/Api";
import { toast } from "react-toastify";

const AdditionalDetails = () => {

  const [financialAdvisor, setFinanncialAdvisor] = useState("");
  const [testedProfessional, setTestedProfessional] = useState("");
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const auth = useSelector((data) => data?.auth);
  const formData = auth?.businessDetailForm;

  const options = [
    { value: "", label: "Select" },
    { value: "YES", label: "Yes" },
    { value: "NO", label: "No" },
    { value: "NOT_SURE", label: "I'm Looking For One" },
  ];
  const options2 = [
    { value: '', label: 'Select' },
    { value: 'YES', label: 'Yes' },
    { value: 'NO', label: 'No' },
    { value: 'NOT_SURE', label: 'I dont know' },
  ];

  const customStyles = {
    control: (base) => ({
      ...base,
      backgroundColor: "white",
      border: "1px solid #ddd",
      borderRadius: "10px",
      padding: "5px",
      fontSize: "1.2rem",
      cursor: "pointer",

    }),
    menuList: (provided) => ({ ...provided, paddingTop: 0, paddingBottom: 0, }),

    menu: (base) => ({
      ...base,
      backgroundColor: "#173363",
      borderRadius: "4px",
    }),
    option: (base, state) => ({
      ...base,
      backgroundColor: state.isFocused ? "white" : "#173363",
      color: state.isFocused ? "#173363" : "white",
      cursor: "pointer",
      fontSize: "1.2rem",
      // padding: "8px",
      borderRadius: "4px",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    singleValue: (base) => ({
      ...base,
      color: "black",
      fontSize: "1.6rem",
    }),
  };


  const {
    setError,
    clearErrors,
    formState: { errors },
  } = useForm();

  const [registerBusinessForm, { isLoading: registerBusinessFormLoading }] = useRegisterBusinessFormMutation();

  const onSubmit = () => {

    const newData = {
      ...formData,
      additionalDetails: {
        hasFinancialAdvisor: financialAdvisor,
        wantsProfessionalConnection: testedProfessional
      }
    };
    newData.isEligible = true;


    registerBusinessForm({ data: newData })
      .unwrap()
      .then(() => {
        dispatch(emptyBusinessForm(null));
        toast.success("Form submitted successfully");
        navigate(PATHS.home);
      })
      .catch((error) => {
        toast.error("Form Submission Failed");
      });
  };

  const validationHandler = () => {
    let noError = false;

    financialAdvisorValidationHandler();
    testedProfessionalValidationHandler();

    if (financialAdvisor && testedProfessional) {
      onSubmit();
    } else {
      return false;
    }

    return noError;
  };

  const financialAdvisorValidationHandler = () => {
    if (!financialAdvisor) {
      setError("financialAdvisor", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("financialAdvisor");
    }
  };

  const testedProfessionalValidationHandler = () => {
    if (!testedProfessional) {
      setError("testedProfessional", { type: "custom", message: "Option is required" });
    } else {
      clearErrors("testedProfessional");
    }
  };

  useEffect(() => {
    if (financialAdvisor) clearErrors("financialAdvisor");
    if (testedProfessional) clearErrors("testedProfessional");
  }, [financialAdvisor, testedProfessional, clearErrors]);

  return (
    <div className="w-full mb-16">
      {/* <div className="bg-[#F2F2F282] text-center py-40">
        <span className="bg-blue-200 text-black text-[1.2rem] px-6 py-2 rounded-full font-semibold uppercase">
          Contact
        </span>
        <h1 className="text-[3.6rem] font-bold mt-3 smallScreens:text-[3rem]">Additional Details</h1>
      </div> */}

      <div className="mx-auto text-center mb-10 space-x-4 space-y-4 mt-40 tabsBtn">
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.basicInfo)}
        >
          Basic Infomation
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessDetails)}
        >
          Business Details
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.servicesNeeded)}
        >
          Services Needed
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.clientScreening)}
        >
          Client Screening Questions
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#FFFFFF] text-[#818891] border border-[#8188918C]"
          onClick={() => navigate(PATHS.businessFormation)}
        >
          Business Formation Decision
        </button>
        <button
          className="w-full sm:w-auto smallScreens:mx-6  px-4 py-5 text-[1.4rem] font-medium rounded-md bg-[#173363] text-[#FFFFFF] border border-[#8188918C]"
          onClick={() => navigate(PATHS.additionalDetails)}
        >
          Additional Details
        </button>
      </div>

      <div className="flex justify-center items-center p-16 pb-40 min-h-[50vh]">
        <div className="w-3/4 smallScreens:w-full bg-white mt-20 shadow-2xl rounded-xl p-10 md:p-20 relative">
          {/* <div className="text-[2.4rem] text-[#121212] text-center mb-20 font-extrabold">Additional Details</div> */}
          <div className="space-y-8">
            <div className="grid grid-cols-2 gap-8 mt-10">
              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[1rem] mediumScreens:text-[1rem]">
                  Do You Currently Have A Trusted Financial Advisor?
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={options}
                    value={options?.find((option) => option.value === financialAdvisor)}
                    onChange={(selectedOption) => setFinanncialAdvisor(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />
                  {/* <span className="absolute inset-y-0 right-5 flex items-center pointer-events-none">
                    <Dropdown />
                  </span> */}
                </div>
                {errors?.financialAdvisor && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors?.financialAdvisor.message}
                  </p>
                )}
              </div>
              <div >
                <label className="block text-[1.4rem] mb-2 text-[#000000] font-medium smallScreens:text-[0.9rem] mediumScreens:text-[1rem]">
                  Would You Like To Be Connected To A Trusted Professional?
                </label>
                <div className='relative mt-4'>
                  <Select
                    options={options2}
                    value={options2?.find((option) => option.value === testedProfessional)}
                    onChange={(selectedOption) => setTestedProfessional(selectedOption.value)}
                    placeholder="Select"
                    styles={customStyles}
                    className="fix_height_input"
                  />

                  {/* <span className="absolute inset-y-0 right-5 flex items-center pointer-events-none">
                    <Dropdown />
                  </span> */}
                </div>
                {errors?.testedProfessional && (
                  <p className="text-red-500 text-[1.2rem] mt-1">
                    {errors?.testedProfessional.message}
                  </p>
                )}
              </div>
            </div>

            <div className="text-center">
              <button
                type="button"
                className="w-2/3 text-[1.6rem] bg-[#173363] text-white py-4 rounded-lg"
                onClick={validationHandler}
              >
                {registerBusinessFormLoading ? "Loading..." : "Save"}
              </button>
            </div>
          </div>
          <div className="absolute -top-20 -right-20 h-[10rem] w-[10rem] z-[-1]">
            <img src={Oval} alt="oval-img" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdditionalDetails;